document.addEventListener("DOMContentLoaded", () => {
  const kakao_target_btn = document.querySelector('[data-channel-talk]');
  kakao_target_btn.addEventListener('click', ()=>{
    window.ChannelIO('showMessenger');
  })
});
